import useCurrentQuery from '#/trip-planner/hooks/useCurrentQuery';
import useNavigate from '#/shared/hooks/useNavigate';
import { storeItem } from '#/shared/utils/storage';
import { PRINT_TRIP_STORAGE_KEY } from '#/shared/constants';
import ROUTES from '#/constants/routes';
import useTransitiveData from './useTransitiveData';
import useActiveItinerary from './useActiveItinerary';

const usePrintTrip = () => {
  const { navigateInNewTab } = useNavigate();
  const { activeItinerary } = useActiveItinerary();
  const { transitiveData } = useTransitiveData();
  const { currentQuery } = useCurrentQuery();

  const printTrip = () => {
    storeItem(PRINT_TRIP_STORAGE_KEY, {
      activeItinerary,
      currentQuery,
      transitiveData,
    });
    navigateInNewTab(ROUTES.printTrip);
  };

  return {
    printTrip,
  };
};

export default usePrintTrip;
